import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { AnalysisMode } from '@customer/store/apis/investigationsApi';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AnalysisModeLimits } from '../config';

export const useAnalysisModeOptions = (): DropdownItemProps<AnalysisMode>[] => {
  const { t } = useTranslation();

  return useMemo<DropdownItemProps<AnalysisMode>[]>(
    () => [
      {
        key: AnalysisMode.Basic,
        value: AnalysisMode.Basic,
        stringValue: AnalysisMode.Basic,
        label: t('Field.AnalysisMode.OptionLabel', {
          mode: 'Basic' satisfies keyof typeof AnalysisMode,
          count: AnalysisModeLimits[AnalysisMode.Basic].maxAssets,
        }),
      },
      {
        key: AnalysisMode.Enhanced,
        value: AnalysisMode.Enhanced,
        stringValue: AnalysisMode.Enhanced,
        label: t('Field.AnalysisMode.OptionLabel', {
          mode: 'Enhanced' satisfies keyof typeof AnalysisMode,
          count: AnalysisModeLimits[AnalysisMode.Enhanced].maxAssets,
        }),
      },
    ],
    [t],
  );
};
